import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: "[custom-host]",
  standalone: false,
})
export class CustomHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
